<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import api from 'api.js'
export default {
  name: 'App'
  // mounted () {
  //   /// /刷新令牌
  //   // 页面第一次加载时为防止令牌失效，要刷新令牌，先判断是否是登录状态（是否有token），如果是登录状态则调取刷新令牌的接口，成功则用获取新的令牌并替换旧令牌，存储在本地;刷新令牌不成功怎删除本地存储的token
  //   if (localStorage.getItem('Token') != null) {
  //     api.common
  //       .refreshToken(localStorage.getItem('Token'))
  //       .then(res => {
  //         if (res.status === 200) {
  //           // 刷新令牌成功则用获取新的令牌并替换旧令牌，存储在本地
  //           localStorage.setItem('Token', res.data.Token)
  //         }
  //       })
  //       .catch(res => {
  //         // 当传入的旧令牌已经的过期时，则不能获取新的令牌进行替换，则刷新令牌失败，要清除之前的存储（好在相应的时间重新登陆）
  //         // 刷新令牌失败，则清除本地存储
  //         localStorage.clear()
  //       })
  //   }
  // }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue